module.exports = __webpack_public_path__ + "static/media/eye-primary.1c93974a.svg";